import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'tr',
    fallbackLng: 'tr',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    defaultNS: 'common',
    ns: ['common', 'sustainabilityPage'],
  });

// Dil değiştiğinde HTML dir attribute'unu güncelle (Arapça için RTL desteği)
i18n.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng);
  document.documentElement.setAttribute('dir', lng === 'ar' ? 'rtl' : 'ltr');
});

// İlk yüklemede de ayarla
document.documentElement.setAttribute('lang', i18n.language);
document.documentElement.setAttribute('dir', i18n.language === 'ar' ? 'rtl' : 'ltr');

export default i18n;